import endpoints, { formatEndpoint } from '../endpoints';
import { RestManagerWithoutBaseUrl } from '../RestManager';
import sortBy from 'lodash/sortBy';
import { dataSourceTypes } from 'helpers/constants';

class OrganizationManagement {
    getUserOrganizations(params) {

        const endpoint = formatEndpoint(endpoints.organizationManagement.getUserOrganizations);

        return RestManagerWithoutBaseUrl.post(endpoint, params)
            .then((organizations) => {
                const updatedOrganizations = organizations.map((org) => ({
                    ...org,
                    dataSourceType: dataSourceTypes[org.source],
                    organizationID: org.organizationId
                }));
                return sortBy(updatedOrganizations, (org) => org.name);
            });
    }

    getOrganizationByAsset(filter) {
        const endpoint = formatEndpoint(endpoints.organizationManagement.getOrganizationByAsset, { filter });
        return RestManagerWithoutBaseUrl.get(endpoint)
            .then((organization) => {
                if (organization) {
                    organization['organizationID'] = organization.organizationId;
                }
                return organization;
            });
    }

    // Microservice gateway maintenance mode

    getMaintenanceScheduleMicroService(organizationId) {
        const endpoint = formatEndpoint(endpoints.organizationManagement.getMaintenanceScheduleMicroService, { organizationId });
        return RestManagerWithoutBaseUrl.get(endpoint);
    }

    addMaintenanceScheduleMicroService(organizationId, scheduleId, scheduleData) {
        const endpoint = formatEndpoint(endpoints.organizationManagement.addMaintenanceScheduleMicroService, { organizationId, scheduleId });
        return RestManagerWithoutBaseUrl.post(endpoint, scheduleData);
    }

    getLastSelectedOrganization() {
        const endpoint = formatEndpoint(endpoints.organizationManagement.getLastSelectedOrganization);
        return RestManagerWithoutBaseUrl.get(endpoint);
    }

    updateLastSelectedOrganization(organizationId) {
        const endpoint = formatEndpoint(endpoints.organizationManagement.updateLastSelectedOrganization);
        return RestManagerWithoutBaseUrl.put(endpoint, { organizationId });
    }
}

export default new OrganizationManagement();
